function Degree() {
  return " °";
}

export default Degree;
